<template>
  <div class="layout-container">
    <!-- 顶部导航栏 -->
    <header class="header">
      <div class="logo">
        <div class="logo-icon">🛡️</div>
        <span>{{ farmName }}</span>
      </div>

      <div class="nav-right">
        <el-dropdown trigger="click" @command="handleCommand">
          <!-- 触发区域：头像 + 用户名 -->
          <div class="user-header-trigger">
            <el-avatar
              size="36"
              :src="require('@/assets/images/hsdt/user.png')"
            />
            <span class="username">{{ userName || "管理员" }}</span>
            <i class="el-icon-arrow-down arrow-icon"></i>
          </div>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout" divided class="logout-text"
              >退出登录</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: "AppLayout",
  data() {
    return {
      farmName: "",
      userName: "",
    };
  },
  methods: {
    //初始化函数
    initPage() {
      this.farmName = JSON.parse(localStorage.getItem("FARMINFO")).farmName;
      this.userName = JSON.parse(
        localStorage.getItem("COMPANYINFO")
      ).companyUserName;
    },
    handleCommand(command) {
      if (command === "logout") {
        this.logout();
      } else if (command === "userInfo") {
        this.$message.info("打开个人信息");
      } else if (command === "updatePwd") {
        this.$message.info("打开修改密码");
      }
    },

    logout() {
      this.$confirm("确定要退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          window.open(window.location.origin + "/web-client/hsLogin");
        })
        .catch(() => {});
    },
  },

  mounted() {
    this.initPage();
  },
};
</script>

<style scoped lang="scss">
.layout-container {
  height: 100px;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.header {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  padding: 0 20px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  z-index: 1000;
}

.logo {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.logo-icon {
  width: 32px;
  height: 32px;
  background: #00c853;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  color: white;
  font-size: 18px;
}

.nav-right {
  .user-header-trigger {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 20px;
    transition: background 0.2s;

    &:hover {
      background: #f5f7fa;
    }

    .username {
      font-size: 14px;
      color: #303133;
    }
    .arrow-icon {
      font-size: 12px;
      color: #909399;
    }
  }

  // 深度修改下拉菜单样式
  ::v-deep .el-dropdown-menu__item {
    font-size: 14px;
    padding: 10px 20px;
  }
  // 退出登录文字标红
  ::v-deep .logout-text {
    color: #f56c6c;
  }
}
</style>
